import { StorageStrategy } from './storage-strategy.interface';

export class StorageContext<TableMapType> {
    constructor(private strategy: StorageStrategy<TableMapType>) {}
  
    setStrategy(strategy: StorageStrategy<TableMapType>) {
      this.strategy = strategy;
    }
  
    getStrategy() {
      return this.strategy;
    }
  
    async add<K extends keyof TableMapType>(table: K, data: TableMapType[K]): Promise<number> {
      return this.strategy.add(table, data);
    }
  
    async getAll<K extends keyof TableMapType>(table: K): Promise<TableMapType[K][]> {
      return this.strategy.getAll(table);
    }

    async getByField<K extends keyof TableMapType>(table: K, field: keyof TableMapType[K], value: any): Promise<TableMapType[K] | undefined> {
      return this.strategy.getByField(table, field, value);
    }
  
    async getById<K extends keyof TableMapType>(table: K, id: number): Promise<TableMapType[K] | undefined> {
      return this.strategy.getById(table, id);
    }
  
    async update<K extends keyof TableMapType>(
      table: K,
      id: number,
      changes: Partial<TableMapType[K]>
    ): Promise<number> {
      return this.strategy.update(table, id, changes);
    }
  
    async deleteById<K extends keyof TableMapType>(table: K, id?: number): Promise<void> {
      return this.strategy.deleteById(table, id);
    }
  
    async clear<K extends keyof TableMapType>(table: K): Promise<void> {
      return this.strategy.clear(table);
    }
  
    async upsert<K extends keyof TableMapType>(
      table: K,
      whereField: keyof TableMapType[K],
      whereValue: any,
      payload: TableMapType[K]
    ): Promise<void> {
      return this.strategy.upsert(table, whereField, whereValue, payload);
    }
  }